import * as React from "react";
function SvgRobotArm(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M45.2 14.7l-6.9 3.7-5.7-2.6V7.3l5.8-3.1 7 3.6c.9.4 1.9.1 2.3-.7V7c.4-.9.1-2-.9-2.5L38.4 0l-9.5 5v4.3H13.2C12 7.1 9.6 5.6 7 5.6c-3.8 0-6.9 3.1-7 6.9 0 3.8 3 6.8 6.8 6.9.3.1.6.1.9.1l6.4 24.8H4.3c-1 0-1.9.8-1.9 1.9 0 1 .8 1.9 1.9 1.9h25c1 0 1.9-.8 1.9-1.9 0-1-.8-1.9-1.9-1.9H17.8l-6.7-26.4c1.5-1.2 2.5-2.9 2.8-4.8h15v5.2l9.6 4.1 8.6-4.4c.9-.5 1.2-1.6.7-2.5-.5-.9-1.7-1.3-2.6-.8zM3.6 12.5c0-1.7 1.4-3.2 3.1-3.2 1.7 0 3.2 1.4 3.2 3.1 0 1.7-1.4 3.2-3.1 3.2h-.1c-1.7 0-3.1-1.4-3.1-3.1z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgRobotArm);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
